import { useNavigate } from "react-router-dom";

function useUrlRedirect() {
  const navigate = useNavigate();
  return (url: any, state: any) => {
    const elm = document.createElement("input");
    elm.setAttribute("type", "url");
    elm.value = url;
    if (elm.validity.valid) {
      window.location.href = url;
    } else {
      navigate(url, state);
    }
  };
}

export default useUrlRedirect;
